<template>
  <div
    fluid
    text-center
  >
    <v-alert
      v-model="alerta.mostrar"
      dismissible
      :type="alerta.tipo"
    >
      {{alerta.mensaje}}
    </v-alert>
    <el-listado
      v-if="listado.mostrar"
      v-bind="listado"
      v-bind:permiso="permiso"
      v-bind:modelo-api="modeloApi"
      v-on:editarItem="editar"
      v-on:crearItem="crear"
      v-on:verItem="ver"
      v-on:mostrarError="mostrarError"
    ></el-listado>

  </div>
</template>

<script>
import mixinAbm from '@/mixins/abm'
import ElListado from './NotificacionesAbmListado'
import Modelo from '@/api/notificacion'

export default {
  mixins: [mixinAbm],
  components: {
    ElListado
  },
  props: {
    componente: {
      type: String,
      default: 'listado'
    },
    soloLectura: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      permiso: 'admin_notificaciones',
      modeloApi: Modelo,
      permisos: {
        mostrar: false,
        item: {},
        operacion: null,
        titulo: 'Editar'
      }
    }
  },
  mounted () {
    if (this.componente === 'listado') {
      this.listado.mostrar = true
    }
  },
  methods: {
    ver (item) {
      this.$router.push({ name: 'instituciones:ver', params: { id: item.id } })
    }

  }
}
</script>

<style lang="scss" scoped>
</style>
